import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled from 'styled-components'

interface IProps {
  children?: React.ReactNode
}

const SContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  justify-content: flex-end;
  margin: 0 20px;
`;

const LandingBackground = (props: IProps) => {
  const { children} = props
  return (
        <SContentContainer>
           { children }
        </SContentContainer>        
    )
}

LandingBackground.propTypes = {
  children: PropTypes.node,
}

export default LandingBackground;